export default __webpack_public_path__ + "static/media/3.67e583d3.jpg";